import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { ThemeColor } from '../../themes';
import { Icon } from '../Icon';
import Spinner from '../Spinner';
import { CloseButton, ContentContainer, DecorationContainer, StyledAlertBanner } from './AlertBanner.style';
export type AlertBannerType = 'error' | 'loading' | 'success';
type Props = {
  type: AlertBannerType;
  isOverlay?: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};
export const AlertBanner: FC<Props> = t0 => {
  const $ = _c(30);
  const {
    type,
    children,
    onClose,
    isOverlay: t1
  } = t0;
  const isOverlay = t1 === undefined ? false : t1;
  const theme = useTheme();
  let t2;
  if ($[0] !== theme.colors.semanticNegative || $[1] !== theme.colors.typeDarkPrimary) {
    t2 = {
      $fgColor: theme.colors.typeDarkPrimary,
      $bgColor: theme.colors.semanticNegative
    };
    $[0] = theme.colors.semanticNegative;
    $[1] = theme.colors.typeDarkPrimary;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== theme.colors.bgSecondary || $[4] !== theme.colors.typePrimary) {
    t3 = {
      $fgColor: theme.colors.typePrimary,
      $bgColor: theme.colors.bgSecondary
    };
    t4 = {
      $fgColor: theme.colors.typePrimary,
      $bgColor: theme.colors.bgSecondary
    };
    $[3] = theme.colors.bgSecondary;
    $[4] = theme.colors.typePrimary;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      error: t2,
      loading: t3,
      success: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const bannerStyles = t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      error: "typeDarkPrimary",
      loading: "black",
      success: "black"
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const closeIconColorMap = t6;
  const t7 = bannerStyles[type];
  let t8;
  if ($[12] !== type) {
    t8 = type === "loading" && <DecorationContainer><Spinner size="small" /></DecorationContainer>;
    $[12] = type;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== type) {
    t9 = type === "success" && <DecorationContainer><Icon icon="Success" size="s" color="semanticPositive" alt="success" /></DecorationContainer>;
    $[14] = type;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== children || $[17] !== t8 || $[18] !== t9) {
    t10 = <ContentContainer>{t8}{t9}{children}</ContentContainer>;
    $[16] = children;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = closeIconColorMap[type];
  let t12;
  if ($[20] !== t11) {
    t12 = <Icon icon="XSmall" alt="close banner" color={t11} />;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== onClose || $[23] !== t12) {
    t13 = <CloseButton onClick={onClose}>{t12}</CloseButton>;
    $[22] = onClose;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isOverlay || $[26] !== t10 || $[27] !== t13 || $[28] !== t7) {
    t14 = <StyledAlertBanner {...t7} $overlay={isOverlay} data-testid="alert-banner">{t10}{t13}</StyledAlertBanner>;
    $[25] = isOverlay;
    $[26] = t10;
    $[27] = t13;
    $[28] = t7;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};